import { WatchlistTranslation } from 'locales/de/pages/Watchlist/watchlist';

const en: WatchlistTranslation = {
  title: 'Watchlist',
  columns: {
    title: 'Title',
    description: 'Description',
    category: 'Category',
    delete: 'Delete Entry',
    tooltip:
      'If a date is coloured red, this indicates that an action is necessary or that something is taking place today.',
    startdate: 'Start date',
    releaseDate: 'Release date',
    eventDate: 'Event date',
    notedOn: 'Noted on',
    deadline: 'Deadline on',
    noInfo: 'No info available'
  }
};

export default en;
